<mat-checkbox
  [(ngModel)]="selectedAll"
  (change)="selectAllClicked()"
  class="helper-checkbox"
  >Select All</mat-checkbox
>
<mat-checkbox
  *ngFor="let category of helperCategories"
  [(ngModel)]="selectedHelperCategories[category]"
  (change)="selectHelperCategoryClicked(category)"
  class="helper-checkbox"
  >{{ category }}</mat-checkbox
>
<ng-select
  [items]="items"
  [multiple]="true"
  [closeOnSelect]="false"
  [bindLabel]="bindLabel"
  [groupBy]="groupBy"
  [placeholder]="placeholder"
  [(ngModel)]="selectedItems"
  (change)="itemSelected()"
>
</ng-select>
